import React from 'react';
import { MicroAppCustomProps } from '@wppopen/core';
import { OsProvider } from '@wppopen/react';

import { AppWithOSContext } from './AppWithOSContext';

export const Root = (props: MicroAppCustomProps) => {
    return (
        <React.StrictMode>
            <OsProvider {...props}>
                <AppWithOSContext />
            </OsProvider>
        </React.StrictMode>
    );
};
